import { useMemo } from "react";

import { company } from "../config";
import { useT } from "./index";

// Values interpolated into copy via the {placeholder} syntax in the
// dictionaries. Kept in one place so a copy string can reference the company
// details without importing config itself.
//
// Every value has a fallback that reads sensibly in a sentence, because the
// real registered details land in .env later and the site must never render a
// gap in the middle of a legal paragraph.

export const templateVars = {
  brand: company.brand,
  legalName: company.legalName,
  jurisdiction: company.jurisdiction,
  location: company.location,
  email: company.email || "our contact address",
  address: company.address || "our registered address",
};

// Language-aware variant. Use this inside components.
//
// The jurisdiction is the one value that cannot be a single translated string:
// "the State of New Mexico" dropped into a Spanish sentence produces "las leyes
// de the State of New Mexico", and forcing the article into the variable breaks
// on the de + el contraction. So each translation supplies the bare place name
// in `legal.jurisdictionName` and carries the grammar in its own sentences
// ("las leyes del estado de {jurisdiction}").
//
// English defines no such key, so it falls through to the full config value.
export function useTemplateVars() {
  const { t } = useT();

  return useMemo(() => {
    const key = "legal.jurisdictionName";
    const localised = t(key);
    return {
      ...templateVars,
      jurisdiction: localised === key ? templateVars.jurisdiction : localised,
    };
  }, [t]);
}
